module.exports = __webpack_public_path__ + "static/media/thermoready-2.4ba3dfb3.png";